import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-close-confirmation',
  templateUrl: './close-confirmation.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./close-confirmation.component.scss']
})
export class CloseConfirmationComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<CloseConfirmationComponent>,) { }

  ngOnInit(): void {
  }

}
